import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import trim from 'lodash/trim';
import sensor from 'components/sensor';

/**
 * === StringCutter Component ===
 * обрезает строку по переданному максимальному числу символов и добавляет троеточие
 *
 * = Example =
 * <StringCutter
 *   string={string}
 * />
 */

@sensor
export default class StringCutter extends PureComponent {
  static propTypes = {
    string: PropTypes.string.isRequired,
    maxCharacters: PropTypes.number,
    dontCutOnTablet: PropTypes.bool,
    dontCutOnDesktop: PropTypes.bool
  };

  static defaultProps = {
    maxCharacters: 67
  };

  constructor(...props) {
    super(...props);
    this.onResizeComponent = this.onResizeComponent.bind(this);
    this.onResize = this.onResizeComponent;
    this.state = {
      device: 'desktop'
    };
  }

  componentDidMount() {
    this.onResizeComponent(this.sensor.getRuntime());
  }

  onResizeComponent({ media: { desktop, tablet, phone } = {} }) {
    const { device } = this.state;
    if (desktop && device !== 'desktop') return this.setState({ device: 'desktop' });
    if (tablet && device !== 'tablet') return this.setState({ device: 'tablet' });
    if (phone && device !== 'phone') return this.setState({ device: 'phone' });
  }

  cutString() {
    const { string, maxCharacters, dontCutOnDesktop, dontCutOnTablet } = this.props;
    const { device } = this.state;

    if (
      (device === 'desktop' && !dontCutOnDesktop) ||
      (device === 'tablet' && !dontCutOnTablet) ||
      string.length <= maxCharacters
    ) return string;

    return trim(`${string.slice(0, maxCharacters - 1)}...`);
  }

  render() {
    return this.cutString();
  }
}
